import {
  Activity01Icon,
  AiBrain01Icon,
  Analytics01Icon,
  AnalyticsUpIcon,
  CommandLineIcon,
  ComputerProgramming01Icon,
  DashboardSpeed01Icon,
  FlashIcon,
  HealthIcon,
  Home01Icon,
  Megaphone02Icon,
  Money01Icon,
  Notification01Icon,
  PaintBoardIcon,
  PlayCircleIcon,
  SearchIcon,
  Settings01Icon,
  Store01Icon,
  TimeScheduleIcon,
  TokenCircleIcon,
  UserGroup03Icon,
  Video01Icon,
  Wallet01Icon,
  WebDesign02Icon,
  ModernTvIcon,
  HeadphonesIcon,
  ShoppingCart01Icon,
  HierarchyCircle03Icon,
} from '@hugeicons-pro/core-stroke-rounded'

export const TYPE_LABELS: Record<string, string> = {
  navigate: 'Navigate',
  new: 'New',
  campaigns: 'Campaigns',
  media: 'Videos',
  activity: 'Activity',
  conversations: 'Conversations',
}

export const NAV_SHORTCUTS = [
  { id: 'home', label: 'Home', icon: Home01Icon, url: '/' },
  { id: 'marketplace', label: 'Marketplace', icon: Store01Icon, url: '/marketplace' },
  { id: 'overview', label: 'Overview', icon: AnalyticsUpIcon, url: '/overview' },
  { id: 'customers', label: 'Customers', icon: UserGroup03Icon, url: '/customers' },
  { id: 'campaigns', label: 'Campaigns', icon: Megaphone02Icon, url: '/campaigns' },
  { id: 'creatives', label: 'Creatives', icon: PlayCircleIcon, url: '/creatives' },
  { id: 'budget', label: 'Budget', icon: Money01Icon, url: '/budget' },
  { id: 'wallet', label: 'Wallet', icon: Wallet01Icon, url: '/wallet' },
  { id: 'channels-search', label: 'Search channel', icon: SearchIcon, url: '/channels/search' },
  { id: 'channels-social', label: 'Social channel', icon: UserGroup03Icon, url: '/channels/social' },
  { id: 'channels-tv', label: 'TV / CTV channel', icon: ModernTvIcon, url: '/channels/tv' },
  { id: 'channels-programmatic', label: 'Programmatic channel', icon: HierarchyCircle03Icon, url: '/channels/programmatic' },
  { id: 'channels-audio', label: 'Audio channel', icon: HeadphonesIcon, url: '/channels/audio' },
  { id: 'channels-retail', label: 'Retail Media channel', icon: ShoppingCart01Icon, url: '/channels/retail' },
  { id: 'properties', label: 'Properties', icon: WebDesign02Icon, url: '/properties' },
  { id: 'connectors', label: 'Connectors', icon: ComputerProgramming01Icon, url: '/connectors' },
  { id: 'commands', label: 'Commands', icon: FlashIcon, url: '/commands' },
  { id: 'scheduled', label: 'Scheduled', icon: TimeScheduleIcon, url: '/scheduled' },
  { id: 'activity', label: 'Activity', icon: Activity01Icon, url: '/activity' },
  { id: 'alerts', label: 'Alerts', icon: Notification01Icon, url: '/alerts' },
  { id: 'usage', label: 'Usage', icon: TokenCircleIcon, url: '/usage' },
  { id: 'health', label: 'Health', icon: HealthIcon, url: '/health' },
  { id: 'developers', label: 'Developers', icon: CommandLineIcon, url: '/developers' },
  { id: 'settings', label: 'Settings', icon: Settings01Icon, url: '/settings' },
  { id: 'videos', label: 'Videos', icon: Video01Icon, url: '/videos' },
  { id: 'work', label: 'Work', icon: DashboardSpeed01Icon, url: '/work' },
  { id: 'subagents', label: 'Subagents', icon: AiBrain01Icon, url: '/subagents' },
  { id: 'admin', label: 'Admin', icon: Analytics01Icon, url: '/admin' },
  { id: 'brand', label: 'Brand', icon: PaintBoardIcon, url: '/brand' },
] as const

export const NEW_SHORTCUTS = [
  { id: 'new-campaign', label: 'New Campaign', intent: 'campaign' },
  { id: 'new-video', label: 'New Video', intent: 'video' },
] as const

export const CAMPAIGN_STATUS_COLORS: Record<string, string> = {
  active: 'bg-green-500',
  paused: 'bg-amber-500',
  draft: 'bg-neutral-400',
}

export function filterNavShortcuts(query: string) {
  const q = query.trim().toLowerCase()
  if (!q) return [...NAV_SHORTCUTS]
  return NAV_SHORTCUTS.filter(
    (item) =>
      item.label.toLowerCase().includes(q) ||
      item.url.toLowerCase().includes(q) ||
      item.id.toLowerCase().includes(q),
  )
}
